import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom"; 
import { 
  FiHome, 
  FiPackage, 
  FiShoppingCart, 
  FiUsers, 
  FiGift, 
  FiCreditCard, 
  FiSliders, 
  FiList, 
  FiMessageCircle, 
  FiCheckCircle, 
  FiTruck , FiUserCheck , FiFileText, 
} from "react-icons/fi";
import { BiLogOut } from "react-icons/bi";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

function Sidebar() {
  const location = useLocation();
  const [openMenu, setOpenMenu] = useState(null);


  const navigate = useNavigate();

  // --- SECURITY CHECK: Redirect if not logged in ---
useEffect(() => {
  const adminId = localStorage.getItem("admin_id");
  if (!adminId) {
    navigate("/");
  }
}, [navigate]);


const handleLogout = (e) => {
  e.preventDefault(); // Prevent default navigation

  Swal.fire({
    title: "Logout?",
    text: "Are you sure you want to exit the admin panel?",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Yes, Logout!",
    cancelButtonText: "Cancel"
  }).then((result) => {
    if (result.isConfirmed) {
      // 1. Remove specific admin keys
      localStorage.removeItem("admin_id");
      localStorage.removeItem("admin_uuid");
      localStorage.removeItem("admin_name");
      localStorage.removeItem("admin_role");

      // 2. Optional: Show success toast before redirecting
      Swal.fire({
        icon: "success",
        title: "Logged Out",
        text: "Redirecting to login...",
        timer: 1500,
        showConfirmButton: false
      });

      // 3. Navigate to root/login
      setTimeout(() => {
        navigate("/");
      }, 1500);
    }
  });
};


  useEffect(() => {
    // Auto-open relevant dropdowns based on URL
    if (location.pathname.startsWith("/product-")) setOpenMenu("productDelivery");
    else if (location.pathname.startsWith("/vendor")) setOpenMenu("vendor");
    else if (location.pathname.startsWith("/user")) setOpenMenu("user");
  }, [location]);

  const toggleMenu = (menu) => {
    setOpenMenu(openMenu === menu ? null : menu);
  };

  return (
    <aside className="sidebar-wrapper">
      <div className="sidebar-header">
        {/* <div className="logo-icon">
          <img src="images/logo.jpg" className="logo-img" alt="Logo" />
        </div> */}
        <div className="logo-name flex-grow-1">
          <h5 className="mb-0">Admin</h5>
        </div>
         
      </div>

      <div className="sidebar-nav">
        <ul className="sidenav">

          {/* Dashboard */}
          <li>
            <Link to="/dashboard" className={location.pathname === "/dashboard" ? "active" : ""}>
              <div className="parent-icon"><FiHome size={20} /></div>
              <div className="menu-title">Dashboard</div>
            </Link>
          </li>

          {/* Product & Delivery */}
          <li className={`dropdown ${openMenu === "productDelivery" ? "open" : ""}`}>
            <button className="dropdown-toggle" onClick={() => toggleMenu("productDelivery")}>
              <div className="parent-icon"><FiPackage size={20} /></div>
              <div className="menu-title">Product & Delivery</div>
              <span className="material-icons-outlined arrow">{openMenu === "productDelivery" ? "expand_less" : "expand_more"}</span>
            </button>
            <ul className="submenu">
              <li>
                <Link to="/product-availability" className={location.pathname === "/product-availability" ? "active" : ""}>
                  <FiCheckCircle size={16} className="me-2" /> Product Availability
                </Link>
              </li>
              {/* <li>
                <Link to="/delivery-cost" className={location.pathname === "/delivery-cost" ? "active" : ""}>
                  <FiTruck size={16} className="me-2" /> Delivery Cost
                </Link>
              </li> */}


              {/* <li>
                <Link to="/stock" className={location.pathname === "/delivery-cost" ? "active" : ""}>
                  <FiTruck size={16} className="me-2" /> Stock Management
                </Link>
              </li> */}


              {/* <li>
                <Link to="/delivery-cost" className={location.pathname === "/delivery-cost" ? "active" : ""}>
                  <FiTruck size={16} className="me-2" /> Delivery Cost
                </Link>
              </li> */}


            </ul>
          </li>



          {/* Order Management */}
<li className={`dropdown ${openMenu === "orderManagement" ? "open" : ""}`}>
  <button className="dropdown-toggle" onClick={() => toggleMenu("orderManagement")}>
    <div className="parent-icon"><FiPackage size={20} /></div>
    <div className="menu-title">Order Management</div>
    <span className="material-icons-outlined arrow">
      {openMenu === "orderManagement" ? "expand_less" : "expand_more"}
    </span>
  </button>
  <ul className="submenu">
    <li>
      <Link
        to="/all-orders"
        className={location.pathname === "/all-orders" ? "active" : ""}
      >
        <FiList size={16} className="me-2" /> All Orders
      </Link>
    </li>

<li>
      <Link
        to="/vendor-cancel-order"
        className={location.pathname === "/all-orders" ? "active" : ""}
      >
        <FiList size={16} className="me-2" /> Vendor Cancel Orders
      </Link>
    </li>
    


    {/* <li>
      <Link
        to="/assigned-orders"
        className={location.pathname === "/assigned-orders" ? "active" : ""}
      >
        <FiUserCheck size={16} className="me-2" /> Assigned Orders
      </Link>
    </li> */}
    <li>
      <Link
        to="/invoices"
        className={location.pathname === "/invoices" ? "active" : ""}
      >
        <FiFileText size={16} className="me-2" /> Invoices
      </Link>
    </li>
    {/* <li>
      <Link
        to="/order-status"
        className={location.pathname === "/order-status" ? "active" : ""}
      >
        <FiCheckCircle size={16} className="me-2" /> Order Status
      </Link>
    </li> */}
  </ul>
</li>




          {/* Vendor Management */}
          <li className={`dropdown ${openMenu === "vendor" ? "open" : ""}`}>
            <button className="dropdown-toggle" onClick={() => toggleMenu("vendor")}>
              <div className="parent-icon"><FiShoppingCart size={20} /></div>
              <div className="menu-title">Vendor Management</div>
              <span className="material-icons-outlined arrow">{openMenu === "vendor" ? "expand_less" : "expand_more"}</span>
            </button>
            <ul className="submenu">
              

              <li>
                <Link to="/all-vendor" className={location.pathname === "/all-vendor" ? "active" : ""}>
                  <FiCheckCircle size={16} className="me-2" /> All Vendor
                </Link>
              </li>


              <li>
                <Link to="/vendor-status" className={location.pathname === "/vendor-status" ? "active" : ""}>
                  <FiUsers size={16} className="me-2" /> Vendor by Status
                </Link>
              </li>
              {/* <li>
                <Link to="/manage-vendor" className={location.pathname === "/manage-vendor" ? "active" : ""}>
                  <FiUsers size={16} className="me-2" /> Manage Vendor
                </Link>
              </li> */}
              <li>
                <Link to="/sku-assured" className={location.pathname === "/sku-assured" ? "active" : ""}>
                  <FiGift size={16} className="me-2" /> SKU “Assured”
                </Link>
              </li>
              <li>
                <Link to="/vendor-reports" className={location.pathname === "/vendor-reports" ? "active" : ""}>
                  <FiList size={16} className="me-2" /> Vendor Reports
                </Link>
              </li>
            </ul>
          </li>

          {/* User Management */}
          <li className={`dropdown ${openMenu === "user" ? "open" : ""}`}>
            <button className="dropdown-toggle" onClick={() => toggleMenu("user")}>
              <div className="parent-icon"><FiUsers size={20} /></div>
              <div className="menu-title">User Management</div>
              <span className="material-icons-outlined arrow">{openMenu === "user" ? "expand_less" : "expand_more"}</span>
            </button>
            <ul className="submenu">
              <li>
                <Link to="/all-users" className={location.pathname === "/all-users" ? "active" : ""}>
                  <FiList size={16} className="me-2" /> All Users
                </Link>
              </li>


              {/* <li>
                <Link to="/user-orders" className={location.pathname === "/user-orders" ? "active" : ""}>
                  <FiList size={16} className="me-2" /> Total Orders
                </Link>
              </li> */}
{/*  
              <li>
                <Link to="/user-cancelled" className={location.pathname === "/user-cancelled" ? "active" : ""}>
                  <FiList size={16} className="me-2" /> Cancelled Orders
                </Link>
              </li>
              <li>
                <Link to="/pending-carts" className={location.pathname === "/pending-carts" ? "active" : ""}>
                  <FiList size={16} className="me-2" /> Pending Carts
                </Link>
              </li> */}
            </ul>
          </li>

          {/* Coupon */}
          <li>
            <Link to="/coupon" className={location.pathname === "/coupon" ? "active" : ""}>
              <div className="parent-icon"><FiGift size={20} /></div>
              <div className="menu-title">Coupon Management</div>
            </Link>
          </li>

          {/* Category & Package */}
          <li>
            <Link to="/category-builder" className={location.pathname === "/category-builder" ? "active" : ""}>
              <div className="parent-icon"><FiSliders size={20} /></div>
              <div className="menu-title">Category Management</div>
            </Link>
          </li>

          <li>
            <Link to="/admin-charges" className={location.pathname === "/admin-charges" ? "active" : ""}>
              <div className="parent-icon"><FiSliders size={20} /></div>
              <div className="menu-title">Admin Charges</div>
            </Link>
          </li>



          <li>
            <Link to="/manage-brands" className={location.pathname === "/manage-brands" ? "active" : ""}>
              <div className="parent-icon"><FiSliders size={20} /></div>
              <div className="menu-title">Brand Management</div>
            </Link>
          </li>


          

          {/* <li>
            <Link to="/package" className={location.pathname === "/package" ? "active" : ""}>
              <div className="parent-icon"><FiPackage size={20} /></div>
              <div className="menu-title">Package Management</div>
            </Link>
          </li> */}

          {/* Orders */}
          {/* <li>
            <Link to="/orders" className={location.pathname === "/orders" ? "active" : ""}>
              <div className="parent-icon"><FiList size={20} /></div>
              <div className="menu-title">Vendor Orders</div>
            </Link>
          </li> */}

          {/* User Comments */}
          <li>
            <Link to="/comments" className={location.pathname === "/comments" ? "active" : ""}>
              <div className="parent-icon"><FiMessageCircle size={20} /></div>
              <div className="menu-title">User Comments</div>
            </Link>
          </li>

          {/* Refund Requests */}
          {/* <li>
            <Link to="/refunds" className={location.pathname === "/refunds" ? "active" : ""}>
              <div className="parent-icon"><FiCreditCard size={20} /></div>
              <div className="menu-title">Refund Requests</div>
            </Link>
          </li> */}

          {/* Payment Gateways */}
          {/* <li>
            <Link to="/payment" className={location.pathname === "/payment" ? "active" : ""}>
              <div className="parent-icon"><FiCreditCard size={20} /></div>
              <div className="menu-title">Payment Gateways</div>
            </Link>
          </li> */}


<li>
            <Link to="/all-contact-form" className={location.pathname === "/all-contact-form" ? "active" : ""}>
              <div className="parent-icon"><FiSliders size={20} /></div>
              <div className="menu-title">All Contact Form</div>
            </Link>
          </li>



<li>
            <Link to="/all-support" className={location.pathname === "/all-support" ? "active" : ""}>
              <div className="parent-icon"><FiSliders size={20} /></div>
              <div className="menu-title">All Support Ticket</div>
            </Link>
          </li>


          {/* Interface Control */}
          <li>
            <Link to="/interface" className={location.pathname === "/interface" ? "active" : ""}>
              <div className="parent-icon"><FiSliders size={20} /></div>
              <div className="menu-title">Interface Control</div>
            </Link>
          </li>


          <li>
            <Link to="/ads" className={location.pathname === "/ads" ? "active" : ""}>
              <div className="parent-icon"><FiSliders size={20} /></div>
              <div className="menu-title">Website Ads</div>
            </Link>
          </li>


          <li>
            <Link to="/manage-pincode" className={location.pathname === "/manage-pincode" ? "active" : ""}>
              <div className="parent-icon"><FiSliders size={20} /></div>
              <div className="menu-title">Manage Pincode</div>
            </Link>
          </li>



<hr/>
<li>
  <a 
    href="#logout" 
    onClick={handleLogout}  
    style={{ cursor: 'pointer' }}
  >
    <div className="parent-icon"><BiLogOut size={20} /></div>
    <div className="menu-title">Logout</div>
  </a>
</li>


        </ul>
      </div>
    </aside>
  );
}

export default Sidebar;
